<template>
    <span>
        <span v-if="prefix">{{prefix}}</span>
        <span>{{description}}</span>
    </span>
</template>

<script>
export default {
    name: 'description',
    props: {
        obj: {
            type: Object,
            default: null
        },
        prefix: {
            type: String
        }
    },
    data() {
        return {
            description: null
        };
    },
    created() {
        if (this.obj.name && this.obj.address) this.description = `${this.obj.name}, ${this.obj.address}`;
        else if (this.obj.name) this.description = this.obj.name;
        else if (this.obj.address) this.description = this.obj.address;
        else if (this.obj.description) this.description = this.obj.description;
        else if (this.obj.currency) this.description = `${this.obj.currency}`;
        else this.description = this.obj.branch;
    }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/description/description.vue